/* Oak Forge - countdown 18h loop */
(function () {
  if (window.ofCampanha) return;
  var CYCLE = 18 * 3600 * 1000;
  var TZ = 'Europe/Dublin';

  function calcFim() {
    var agora = Date.now();
    var resto = agora % CYCLE;
    return agora - resto + CYCLE;
  }

  var fim = calcFim();
  var dia = function (ms) {
    return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ms));
  };
  var dois = function (n) { return (n < 10 ? '0' : '') + n; };

  function mostraBar() {
    document.querySelectorAll('[data-of-camp]').forEach(function (e) { e.style.display = 'flex'; });
    document.querySelectorAll('.announcement-bar-section').forEach(function (e) { e.style.display = 'none'; });
  }
  function ocultaBar() {
    document.querySelectorAll('[data-of-camp]').forEach(function (e) { e.remove(); });
    document.querySelectorAll('.of-camp-section style').forEach(function (s) { s.remove(); });
    document.querySelectorAll('.announcement-bar-section').forEach(function (e) { e.style.display = ''; });
    document.querySelectorAll('[data-of-selo-fim]').forEach(function (e) { e.hidden = true; });
  }
  function selo(agora) {
    var ultimo = dia(fim - 1000), hoje = dia(agora), amanha = dia(agora + 86400000);
    var txt = hoje === ultimo ? 'ENDS TODAY' : amanha === ultimo ? 'ENDS TOMORROW' : '';
    document.querySelectorAll('[data-of-selo-fim]').forEach(function (e) {
      e.textContent = txt ? ' | ' + txt : '';
      e.hidden = !txt;
    });
  }

  var id;
  function tick() {
    var agora = Date.now();
    var falta = Math.max(0, Math.floor((fim - agora) / 1000));
    if (!falta) {
      fim = calcFim();
      falta = Math.max(0, Math.floor((fim - agora) / 1000));
    }
    var v = { d: Math.floor(falta / 86400), h: Math.floor(falta % 86400 / 3600), m: Math.floor(falta % 3600 / 60), s: falta % 60 };
    document.querySelectorAll('[data-of-camp] [data-u]').forEach(function (e) {
      var t = dois(v[e.getAttribute('data-u')]);
      if (e.textContent !== t) e.textContent = t;
    });
    selo(agora);
    mostraBar();
  }

  window.ofCampanha = { fim: fim, tick: tick };
  tick();
  id = setInterval(tick, 1000);
})();